module.exports = __webpack_public_path__ + "img/bankit-pay.abd61a31.png";